import { DataLayer } from '@grandvisionhq/analytics';
import { State } from '@grandvisionhq/auth';

const getUserId = (authState)=>authState.userId.split('|')[1] // id in format <proivder>|<auth0id>
;
function createUser(authState, hideUserData) {
    if (State.isUninitialized(authState)) {
        throw new Error('Can not build meaningful user data when unintialized');
    }
    if (State.isLoggedIn(authState)) {
        const id = hideUserData ? {
            auth0: '',
            auth0_email: ''
        } : {
            auth0: getUserId(authState),
            auth0_email: authState.email
        };
        return {
            id,
            loginStatus: true
        };
    } else {
        return {
            id: {
                auth0: '',
                auth0_email: ''
            },
            loginStatus: false
        };
    }
}
const clearEvents = ()=>{
    return DataLayer.Actions.pushEvent({
        events: null
    });
};

export { clearEvents, createUser };
//# sourceMappingURL=utils.js.map
